import React, { ReactNode } from "react";
import ErrorBoundary from "../system/ErrorBoundary";

interface SimpleLayoutProps {
  children: ReactNode;
}

const SimpleLayout: React.FC<SimpleLayoutProps> = ({ children }) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default SimpleLayout;
